module.exports = __webpack_public_path__ + "files/b9a1bc6f0c4d2353933422a0873af064.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-1.png
// module id = 519
// module chunks = 76